import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Spin, message, Form, DatePicker, Button, Row, Col, Radio } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SemiCirclePieChart from "./SemiCircle";
import moment from "moment";
import liracrypt from "../../Liracrypt/liracrypt";
import { getStyleProperties } from "../../../utils/CustomFunc";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

const SemiCircleParent = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [graphData, setGraphData] = useState({
    chartConfig: null,
    loading: false,
    records: null,
    blockConfig: null,
  });
  const [loginError, setLoginError] = useState(false);

  const fetchGraphData = () => {
    setGraphData({ ...graphData, loading: true });
    liracrypt
      .get("/modelchartsemicircle", {})
      .then((res, req) => {
        if (res) {
          let data = res.data && res.data.data ? res.data.data : null;
          
          const graphsVisualisation = data.config.graphsVisualisation;
          const configBlock = {
            title: {
              text: data.config.chartTitle["title-label"],
              style: getStyleProperties(data.config.chartTitle["title-label"]),
            },

            style: {
              backgroundColor: data.config.chartConfig.divBackgroundColor,
              textAlign: data.config.chartConfig.divAlignment,
              marginLeft: data.config.chartConfig.leftMargin,
            },
          };
          const config = {
            width: data.config.chartConfig.chartWidth,
            height: data.config.chartConfig.chartHeight,
            chart: {
              radius: graphsVisualisation["piechart-prop"]["chart-radius"],
              innerRadius:
                graphsVisualisation["piechart-prop"]["chart-innerRadius"],
              startAngle:
                graphsVisualisation["piechart-prop"]["chart-startAngle"],
              endAngle: graphsVisualisation["piechart-prop"]["chart-endAngle"],
            },
            series: {
              cornerRadius:
                graphsVisualisation["series-prop"][
                  "series-slices-cornerradius"
                ],
              innerCornerRadius:
                graphsVisualisation["series-prop"][
                  "series-slices-innercornerradius"
                ],
              draggable:
                graphsVisualisation["series-prop"]["series-slices-draggable"],
              inert: graphsVisualisation["series-prop"]["series-slices-inert"],
              alignLabels:
                graphsVisualisation["series-prop"]["series-slices-alignlabels"],
              startAngle:
                graphsVisualisation["series-prop"][
                  "series-hiddenState-startangle"
                ],
              startAngle:
                graphsVisualisation["series-prop"][
                  "series-hiddenState-endangle"
                ],
              value:
                graphsVisualisation["series-prop"]["series-dataFields-value"],
              category:
                graphsVisualisation["series-prop"][
                  "series-dataFields-category"
                ],
            },
          };

          setGraphData({
            chartConfig: config,
            loading: false,
            records: data.config.data,
            blockConfig: configBlock,
          });
        }
      })
      .catch(function (error) {
        // setGraphData({
        //   chartConfig: null,
        //   loading: false,
        //   records: null,
        //   blockConfig: null,
        // });
        console.log("Error****: fetch calendar", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (
      graphData.chartConfig == null &&
      graphData.loading === false &&
      graphData.records == null &&
      graphData.blockConfig == null
    ) {
      
      fetchGraphData();
    }
  }, [graphData]);

  return (
    <>
      <SessionError visible={loginError} />
      <div style={{ padding: "20px 10px" }}>
        {graphData.records !== null && graphData.chartConfig !== null ? (
          <div
            style={{
              backgroundColor: "#27293d",
              marginTop: "20px",
              padding: "20px 0",
            }}
          >
            <SemiCirclePieChart
              data={graphData.records}
              divId={"SemiCircle"}
              config={graphData.chartConfig}
            />
          </div>
        ) : graphData.loading ? (
          <div className="Loading">
            <Spin indicator={antIcon} tip="Loading..." />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default SemiCircleParent;
